// extracted by mini-css-extract-plugin
export default {"daysOfWeek":"DaysOfWeek-daysOfWeek-DQmbR"};